import React from 'react';

export const EmojiPickerIcon: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='var(--text-mid-emphasis)'
      fillRule='evenodd'
      d='M6.343 6.343a8 8 0 1111.314 11.314A8 8 0 016.343 6.343zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1.44 8.56a1.5 1.5 0 10-2.12-2.12 1.5 1.5 0 002.12 2.12zm5 0a1.5 1.5 0 10-2.12-2.12 1.5 1.5 0 002.12 2.12zm-7.777 2.463a1.001 1.001 0 00-.602 1.551c.677.967 1.973 2.17 3.703 2.53 1.824.379 3.875-.23 5.859-2.435a1.001 1.001 0 10-1.486-1.338c-1.616 1.795-2.982 2.019-3.966 1.815-1.079-.224-1.982-1.021-2.472-1.719a1 1 0 00-1.036-.404z'
      clipRule='evenodd'
    ></path>
  </svg>
);
